<div class="container p-3">
    <div class="row">
        <div class="col">
            <div>
                <button class="btn btn-outline-secondary" (click)="navigateToCommunity()">
                    <i class="fas fa-chevron-left"></i> Back
                </button>
            </div>
        </div>
    </div>
    <hr>
    <div class="row">
        <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <div>
                <community-message-card [message]="message" (commentClick)="refreshComments()" (photoClick)="modalPhoto = $event;" (updateUser)="updateUser($event)"></community-message-card>
                <hr>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="message">
        <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <div>
                <community-new-comment [message]="message" (refreshComments)="refreshComments()"></community-new-comment>
                <hr>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="comments.length > 0">
        <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <div *ngFor="let comment of comments">
                <community-comment-card [comment]="comment" (updateUser)="updateUser($event)"></community-comment-card>
                <hr>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="count > 0 || browseBeforeInProgress">
        <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3 text-center">
            <button class="btn btn-primary mx-auto mb-3" (click)="browseBefore()" [disabled]="browseBeforeInProgress" [class.progress-bar-striped]="browseBeforeInProgress" [class.progress-bar-animated]="browseBeforeInProgress">
                <div *ngIf="!browseBeforeInProgress">
                    <i class="fas fa-step-forward" style="transform: rotate(90deg)"></i> Next
                </div>
                <div *ngIf="browseBeforeInProgress">
                    <i class="fas fa-hourglass-half"></i> Loading
                </div>
            </button>
        </div>
    </div>
    <div id="modalPhoto" class="modal text-center p-4" style="background-color: rgba(0, 0, 0, 0.25)" tabindex="-1" [style.display]="modalPhoto ? 'block' : 'none'" (click)="modalPhoto = null;">
        <img class="mw-100 mh-100" src="{{ modalPhoto }}" (click)="modalPhoto = null;">
    </div>
</div>